import { NestedQuota } from '../../../shared/interfaces/quota.interface';
import { SurveyNestedQuotas } from '../../domain/survey-nested-quotas';

export class NestedQuotaDuplicityFinder {
  constructor(
    private readonly _existingNestedQuotas: NestedQuota[],
    private readonly _upcomingNestedQuotas: NestedQuota[]
  ) {}

  private get _existingSurveyNestedQuotas(): SurveyNestedQuotas {
    return new SurveyNestedQuotas(this._existingNestedQuotas).ungrouped();
  }

  private get _upcomingSurveyNestedQuotas(): SurveyNestedQuotas {
    return new SurveyNestedQuotas(this._upcomingNestedQuotas).ungrouped();
  }

  public matching(): NestedQuota[] {
    const matchingNestedQuotas = this._qualificationCheck();
    if (!matchingNestedQuotas || !matchingNestedQuotas.length) {
      return [];
    }

    return this._conditionCheck(matchingNestedQuotas);
  }

  private _qualificationCheck(): NestedQuota[] {
    const matchingGroupIds = this._existingSurveyNestedQuotas.groupIds().filter(
      (groupId) =>
        this._existingSurveyNestedQuotas.kind(groupId).qualificationIds()
          .length ===
          this._upcomingSurveyNestedQuotas.qualificationIds().length &&
        this._existingSurveyNestedQuotas
          .kind(groupId)
          .qualificationIds()
          .every((qId) =>
            this._upcomingSurveyNestedQuotas.qualificationIds().includes(qId)
          )
    );
    if (!matchingGroupIds || !matchingGroupIds.length) {
      return [];
    }

    return matchingGroupIds
      .map((matchingGroupId) =>
        this._existingSurveyNestedQuotas.kind(matchingGroupId).get()
      )
      .flat();
  }

  private _conditionCheck(matching: NestedQuota[]): NestedQuota[] {
    return matching.filter((matchingQuota) =>
      this._upcomingSurveyNestedQuotas
        .get()
        .some((upcomingQuota) =>
          (matchingQuota.combinedKey ?? []).every((matchingKey) =>
            (upcomingQuota.combinedKey ?? []).includes(matchingKey)
          )
        )
    );
  }
}
